<template>
  <div class="c-route-trajectory">
    <div
      class="c-route-trajectory__number"
      :style = "{
        color: color ? color : null
      }"
      v-if="number"
    >
      {{ number }}
    </div>
    <div class="c-route-trajectory__info">
      <div
        class="c-route-trajectory__label"
        v-if="label"
      >
        {{ label }}
      </div>
      <div
        class="c-route-trajectory__sublabel"
        v-if="sublabel"
      >
        {{ sublabel }}
      </div>
    </div>
    <div
      class="c-route-trajectory__duration"
      v-if="duration"
    >
      {{ duration }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ORouteTrajectory',
  props: {
    label: {
      type: String,
      required: true
    },
    sublabel: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    number: {
      type: String,
      default: null
    },
    duration: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-route-trajectory {
  align-items: flex-start;
  display: flex;
}

.c-route-trajectory__number {
  color: #000;
  flex: none;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  margin-right: 0.8rem;
  position: relative;
  text-align: center;
  width: 2.2rem;

  &:before {
    background: currentColor;
    border-radius: 0.3rem;
    bottom: 0;
    content: '';
    opacity: 0.15;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.c-route-trajectory__info {
  flex: 1 1 0;
}

.c-route-trajectory__sublabel {
  color: $blue-kbc-cement;
  font-size: 1.3rem;
  margin-top: 0.4rem;
}

.c-route-trajectory__duration {
  color: $blue-kbc-cement;
  text-align: right;
}
</style>
